import { FunctionComponent, useState } from 'react'
import { Box } from '@mui/material'
import { useWidgetContext } from '@dxp-module/common'
import MiniWidgetButton from '../widgetButton/MiniWidgetButton'
import MiniWidgetModal from '../widgetModal/MiniWidgetModal'

const MiniWidgetButtonWrapper: FunctionComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const {
    configuration: { loginInModal },
  } = useWidgetContext()

  return (
    <Box>
      <MiniWidgetButton toggleModal={setIsModalOpen} />
      {loginInModal && (
        <MiniWidgetModal isOpen={isModalOpen} toggleModal={setIsModalOpen} />
      )}
    </Box>
  )
}

export default MiniWidgetButtonWrapper
